const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickeName: state => state.user.nickeName,
  dataInfo: state => state.params.dataInfo,
  configKey: state => state.params.configKey,
  refashData:state => state.user.refashData
}
export default getters
